import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './veiculoForm';

import { setModoTela, initForm, salvar, excluir, getLista, getListaTipo, getListaOperacao } from './veiculoActions';
import FormatUtils from '../common/formatUtils/FormatUtils';

class Veiculo extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaOperacao();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({  veiculo: true, ponto_atendimento: false, vendedor: false });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Placa</Th>
								<Th alignCenter colspan={1}>Tipo</Th>
								<Th alignCenter colspan={1}>Modelo</Th>
								<Th alignCenter>Capacidade</Th>
								<Th alignCenter>Alocação</Th>
								<Th alignCenter>Operacao</Th>
								<Th alignCenter>Controle/Dash</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.placa} ${item.modelo || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.placa}</Td>
									<Td alignCenter>{item.nome_tipo}</Td>
									<Td alignCenter>{item.modelo}</Td>
									<Td alignCenter>{parseInt(item.capacidade)}</Td>
									<Td alignCenter>{item.terceiro ? 'TERCEIRIZADO' : 'FROTA'}</Td>
									<Td alignCenter>{item.nome_operacao}</Td>
									<Td alignCenter>{item.controle ? 'SIM' : ''}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													media_minima: FormatUtils.formatarValorTela(item.media_minima, 2),
													custo_km_meta: FormatUtils.formatarValorTela(item.custo_km_meta, 2)
												});
												this.props.initForm({
													...item,
													media_minima: FormatUtils.formatarValorTela(item.media_minima, 2),
													custo_km_meta: FormatUtils.formatarValorTela(item.custo_km_meta, 2)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													media_minima: FormatUtils.formatarValorTela(item.media_minima, 2),
													custo_km_meta: FormatUtils.formatarValorTela(item.custo_km_meta, 2)
												});
												this.props.initForm({
													...item,
													media_minima: FormatUtils.formatarValorTela(item.media_minima, 2),
													custo_km_meta: FormatUtils.formatarValorTela(item.custo_km_meta, 2)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.veiculo.modoTela,
	lista: state.veiculo.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getListaTipo, getListaOperacao }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Veiculo);
